/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useMemo, useState} from "react";
import objectPath from "object-path";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import SVG from "react-inlinesvg";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {toAbsoluteUrl} from "../../../_helpers";
import {AsideSearch} from "./AsideSearch";
import {AsideMenu} from "./aside-menu/AsideMenu";
import {QuickUserToggler} from "../extras/QuickUserToggler";
import {Brand} from "../brand/Brand";
import {KTUtil} from "./../../../_assets/js/components/util";
import AsideItem from "../../../../app/components/AsideItem";
import {useTranslation} from "react-i18next";

export function Aside() {
  const { t } = useTranslation('common');
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      asideClassesFromConfig: uiService.getClasses("aside", true),
      asideSecondaryDisplay: objectPath.get(
        uiService.config,
        "aside.secondary.display"
      ),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      extrasSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      extrasNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      extrasQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      extrasQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      extrasLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      extrasUserDisplay: objectPath.get(
        uiService.config,
        "extras.user.display"
      ),
    };
  }, [uiService]);

  const tabs = {
    tabId1: "kt_aside_tab_1",
    tabId2: "kt_aside_tab_2",
    tabId3: "kt_aside_tab_3",
    tabId4: "kt_aside_tab_4",
    tabId5: "kt_aside_tab_5",
    tabId6: "kt_aside_tab_6",
    tabId7: "kt_aside_tab_7",
    tabId8: "kt_aside_tab_8",
    tabId9: "kt_aside_tab_9",
    tabId10: "kt_aside_tab_10",
    tabId11: "kt_aside_tab_11",
  };
  const [activeTab, setActiveTab] = useState('');
  const handleTabChange = (id) => {
    setActiveTab(id);
    const asideWorkspace = KTUtil.find(
      document.getElementById("kt_aside"),
      ".aside-secondary .aside-workspace"
    );
    if (asideWorkspace) {
      KTUtil.scrollUpdate(asideWorkspace);
    }
  };

  return (
    <>
      {/* begin::Aside */}
      <div
        id="kt_aside"
        className={`aside aside-left d-flex ${layoutProps.asideClassesFromConfig}`}
      >
        {/* begin::Primary */}
        <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">
          <Brand />
          {/* begin::Nav Wrapper */}
          <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid py-5 scroll scroll-pull">
            {/* begin::Nav */}
            <ul className="list-unstyled flex-column" role="tablist">
              <AsideItem
                title={t('MENU.DASHBOARD')}
                tabId={tabs.tabId1}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId1}
                link={"/dashboard"}
                svg={"/media/svg/icons/Layout/Layout-4-blocks.svg"}
              />
              <AsideItem
                title={t('Services')}
                tabId={tabs.tabId2}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId2}
                link={"/service"}
                svg={"/media/svg/icons/Home/Commode1.svg"}
              />
              <AsideItem
                title={t('Rooms')}
                tabId={tabs.tabId3}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId3}
                link={"/room"}
                svg={"/media/svg/icons/Home/Home.svg"}
              />
              <AsideItem
                title={t('Users')}
                tabId={tabs.tabId4}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId4}
                link={"/user"}
                svg={"/media/svg/icons/Communication/Group.svg"}
              />
              <AsideItem
                title={t('Sessions')}
                tabId={tabs.tabId5}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId5}
                link={"/session"}
                svg={"/media/svg/icons/Cooking/Dish.svg"}
              />
              <AsideItem
                title={t('Connections')}
                tabId={tabs.tabId6}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId6}
                link={"/connection"}
                svg={"/media/svg/icons/Devices/LTE1.svg"}
              />
              <AsideItem
                title={t('Files')}
                tabId={tabs.tabId7}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId7}
                link={"/file"}
                svg={"/media/svg/icons/Files/File-cloud.svg"}
              />
              <AsideItem
                title={t('Record')}
                tabId={tabs.tabId11}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId11}
                link={"/record"}
                svg={"/media/svg/icons/Files/Media.svg"}
              />
              <AsideItem
                title={t('Support')}
                tabId={tabs.tabId8}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId8}
                link={"/support"}
                svg={"/media/svg/icons/Communication/Group-chat.svg"}
              />
              <AsideItem
                title={t('Library')}
                tabId={tabs.tabId10}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId10}
                link={"/library"}
                svg={"/media/svg/icons/Home/Book-open.svg"}
              />
              <AsideItem
                title={t('Guide')}
                tabId={tabs.tabId9}
                handleTabChange={handleTabChange}
                activeTab={activeTab === tabs.tabId9}
                externalLink
                link={"https://bellmeet.com/support"}
                svg={"/media/svg/icons/Communication/Flag.svg"}
              />
            </ul>
            {/* end::Nav */}
          </div>
          {/* end::Nav Wrapper */}

          {/* begin::Footer */}
          <div className="aside-footer d-flex flex-column align-items-center flex-column-auto py-4 py-lg-10">
            {/* begin::Aside Toggle */}
            {layoutProps.asideSecondaryDisplay && false &&
              layoutProps.asideSelfMinimizeToggle && (
                <>
                  <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="toggle-aside">Toggle Aside</Tooltip>}
                  >
                    <span
                      className="aside-toggle btn btn-icon btn-primary btn-hover-primary shadow-sm"
                      id="kt_aside_toggle"
                    >
                      <i className="ki ki-bold-arrow-back icon-sm" />
                    </span>
                  </OverlayTrigger>
                </>
              )}
            {/* end::Aside Toggle */}

            {/* begin::Search */}
            {layoutProps.extrasSearchDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="toggle-search">Quick Search</Tooltip>}
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1"
                  id="kt_quick_search_toggle"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}
            {/* end::Search */}

            {/* begin::Notifications */}
            {layoutProps.extrasNotificationsDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="toggle-notifications">Notifications</Tooltip>
                }
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                  id="kt_quick_notifications_toggle"
                  data-placement="right"
                  data-container="body"
                  data-boundary="window"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}
            {/* end::Notifications */}

            {/* begin::Quick Actions */}
            {/*{layoutProps.extrasQuickActionsDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="toggle-quick-actions">Quick Actions</Tooltip>
                }
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1"
                  id="kt_quick_actions_toggle"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Media/Equalizer.svg"
                      )}
                    />
                  </span>
                </a>
              </OverlayTrigger>
            )}*/}
            {/* end::Quick Actions */}

            {/* begin::Quick Panel */}
            {/*{layoutProps.extrasQuickPanelDisplay && (
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="toggle-quick-panel">Quick Panel</Tooltip>}
              >
                <a
                  href="#"
                  className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                  id="kt_quick_panel_toggle"
                  data-placement="right"
                  data-container="body"
                  data-boundary="window"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Layout/Layout-4-blocks.svg"
                      )}
                    />
                  </span>
                  <span className="label label-sm label-light-danger label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1">
                    3
                  </span>
                </a>
              </OverlayTrigger>
            )}*/}
            {/* end::Quick Panel */}

            {/* begin::Languages*/}
            {/*{layoutProps.extrasLanguagesDisplay && <LanguageSelectorDropdown />}*/}
            {/* end::Languages */}

            {/* begin::User*/}
            {layoutProps.extrasUserDisplay && <QuickUserToggler />}
            {/* end::User */}
          </div>
          {/* end::Footer */}
        </div>
        {/* end::Primary */}

        {layoutProps.asideSecondaryDisplay && false && (
          <>
            {/* begin::Secondary */}
            <div className="aside-secondary d-flex flex-row-fluid">
              {/* begin::Workspace */}
              <div className="aside-workspace scroll scroll-push my-2">
                <div className="tab-content">
                  <AsideSearch isActive={activeTab === tabs.tabId1} />
                  <AsideMenu isActive={activeTab === tabs.tabId2} />
                </div>
              </div>
              {/* end::Workspace */}
            </div>
            {/* end::Secondary */}
          </>
        )}
      </div>
      {/* end::Aside */}
    </>
  );
}
